module.exports = __webpack_public_path__ + "img/achieve8.8db40bad.png";